export default "/images/404-footer.svg?92c1157b42bdfb9fe3e2b0b8e3026af4";